// Trang danh sách đề kiểm tra đã tạo

import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Plus, FileText, Trash2, Edit, Calendar, Clock } from 'lucide-react'
import { examMatrixService } from '../../services/exam-matrix/ExamMatrixService'
import { ExamMatrix } from '../../types/exam-matrix'
import toast from 'react-hot-toast'

export const DanhSachDeKiemTra: React.FC = () => {
  const navigate = useNavigate()
  const [matrices, setMatrices] = useState<ExamMatrix[]>([])
  const [loading, setLoading] = useState(true)
  
  useEffect(() => {
    loadMatrices()
  }, [])
  
  const loadMatrices = async () => {
    try {
      const data = await examMatrixService.getAllMatrices()
      setMatrices(data)
    } catch (error) {
      toast.error('Không thể tải danh sách ma trận')
    } finally {
      setLoading(false)
    }
  }
  
  const handleDelete = async (id: string) => {
    if (!confirm('Bạn có chắc muốn xóa ma trận này?')) return
    
    try {
      await examMatrixService.deleteMatrix(id)
      toast.success('Đã xóa ma trận')
      loadMatrices()
    } catch (error) {
      toast.error('Không thể xóa ma trận')
    }
  }
  
  const handleCreateExam = async (matrix: ExamMatrix) => {
    try {
      const quizData = await examMatrixService.generateExamFromMatrix(matrix)
      navigate(`/trac-nghiem/custom/${quizData.id}`, { state: { quizData } })
    } catch (error) {
      toast.error('Không thể tạo đề thi')
    }
  }
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Đang tải...</p>
        </div>
      </div>
    )
  }
  
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Danh Sách Ma Trận Đề Kiểm Tra</h1>
          <button
            onClick={() => navigate('/tao-de-kiem-tra/tao-moi')}
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Plus className="w-5 h-5 mr-2" />
            Tạo ma trận mới
          </button>
        </div>
        
        {matrices.length === 0 ? (
          <div className="text-center py-12 bg-white rounded-lg shadow">
            <FileText className="w-16 h-16 mx-auto mb-4 text-gray-300" />
            <p className="text-lg font-medium text-gray-900 mb-2">Chưa có ma trận nào</p>
            <p className="text-sm text-gray-500 mb-6">Tạo ma trận mới để bắt đầu</p>
            <button
              onClick={() => navigate('/tao-de-kiem-tra/tao-moi')}
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              <Plus className="w-5 h-5 mr-2" />
              Tạo ma trận mới
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {matrices.map(matrix => (
              <div key={matrix.id} className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg text-gray-900 mb-1">{matrix.tenMaTran}</h3>
                    <span className="inline-block px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded">
                      {matrix.loaiKiemTra}
                    </span>
                  </div>
                  <button
                    onClick={() => handleDelete(matrix.id)}
                    className="text-red-500 hover:text-red-700"
                  >
                    <Trash2 className="w-5 h-5" />
                  </button>
                </div>
                
                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-sm text-gray-600">
                    <FileText className="w-4 h-4 mr-2" />
                    Lớp {matrix.lop} - Chương {matrix.cacChuong.join(', ')}
                  </div>
                  <div className="flex items-center text-sm text-gray-600">
                    <Clock className="w-4 h-4 mr-2" />
                    {matrix.thoiGianLamBai} phút - Điểm đạt {matrix.diemDat}%
                  </div>
                  <div className="flex items-center text-sm text-gray-600">
                    <Calendar className="w-4 h-4 mr-2" />
                    {new Date(matrix.createdAt).toLocaleDateString('vi-VN')}
                  </div>
                </div>
                
                <div className="flex gap-2">
                  <button
                    onClick={() => handleCreateExam(matrix)}
                    className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm"
                  >
                    Tạo đề thi
                  </button>
                  <button
                    onClick={() => navigate(`/tao-de-kiem-tra/chinh-sua/${matrix.id}`)}
                    className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                  >
                    <Edit className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

